import './HasMatched.css';
import React from 'react';

const HasMatched = () => {
  return (
    <div className='hearts-effects-container'>
      <img
        className='heart'
        src='https://i.imgur.com/E8cUZgs.png'
        alt='heart'
      />
      <img
        className='heart'
        src='https://i.imgur.com/XO4GKxX.png'
        alt='heart'
      />
      <img
        className='heart'
        src='https://i.imgur.com/75mSSbQ.png'
        alt='heart'
      />
      <img
        className='heart'
        src='https://i.imgur.com/E8cUZgs.png'
        alt='heart'
      />
      <img
        className='heart'
        src='https://i.imgur.com/XO4GKxX.png'
        alt='heart'
      />
      <img
        className='heart'
        src='https://i.imgur.com/75mSSbQ.png'
        alt='heart'
      />
      <img
        className='heart'
        src='https://i.imgur.com/E8cUZgs.png'
        alt='heart'
      />
      <img
        className='heart'
        src='https://i.imgur.com/XO4GKxX.png'
        alt='heart'
      />
      <img
        className='heart'
        src='https://i.imgur.com/75mSSbQ.png'
        alt='heart'
      />
      <img
        className='heart'
        src='https://i.imgur.com/E8cUZgs.png'
        alt='heart'
      />
      <img
        className='heart'
        src='https://i.imgur.com/XO4GKxX.png'
        alt='heart'
      />
      <img
        className='heart'
        src='https://i.imgur.com/75mSSbQ.png'
        alt='heart'
      />
      <img
        className='heart'
        src='https://i.imgur.com/XO4GKxX.png'
        alt='heart'
      />
      <img
        className='heart'
        src='https://i.imgur.com/75mSSbQ.png'
        alt='heart'
      />
      <img
        className='heart'
        src='https://i.imgur.com/E8cUZgs.png'
        alt='heart'
      />
      <img
        className='heart'
        src='https://i.imgur.com/XO4GKxX.png'
        alt='heart'
      />
      <img
        className='heart'
        src='https://i.imgur.com/75mSSbQ.png'
        alt='heart'
      />
      <img
        className='heart'
        src='https://i.imgur.com/E8cUZgs.png'
        alt='heart'
      />
      <img
        className='heart'
        src='https://i.imgur.com/XO4GKxX.png'
        alt='heart'
      />
      <img
        className='heart'
        src='https://i.imgur.com/75mSSbQ.png'
        alt='heart'
      />
    </div>
  );
};

export default HasMatched;
